import React, { useEffect } from 'react';
import './TopAlert.css';

const TopAlert = ({ message, onClose, duration = 5000 }) => {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, onClose, duration]);

  if (!message) return null;

  return (
    <div className="top-alert" role="alert" aria-live="assertive">
      {message}
    </div>
  );
};

export default TopAlert;
